// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsAssignedGender;
(function (HhsAssignedGender) {
    HhsAssignedGender["F"] = "F";
    HhsAssignedGender["M"] = "M";
    HhsAssignedGender["U"] = "U";
})(HhsAssignedGender || (HhsAssignedGender = {}));
//# sourceMappingURL=hhsAssignedGender.js.map